import React from 'react';
import Confetti from 'react-confetti';
import '../Styles/background.css'; // Optional: CSS for styling

const Success = () => {
    const [width, height] = [window.innerWidth, window.innerHeight];

    return (
        <div className="success-container">
            <Confetti width={width} height={height} />

            <div className="success-message">
                <img src="/images/success.webp" alt="Success" className="success-image" /> {/* Use relative URL */}
                <h1>Subscription Successful!</h1>
                <p>Thank you for subscribing to our product!</p>
                <div className="prizes ">
                    <h4>Features of the Services</h4>
                    <ul className='text-start'>
                        <li>Screen brackage </li>
                        <li>Burglary</li>
                        <li>Claim Upto 20,000</li>
                    </ul>
                </div>
            </div>
        </div>
    );
};

export default Success;
